<template>
  <div class="container">
    <div class="server">
      <div class="server-img">
        <div class="server-img-content">
          <div class="server-ic-view">
            <h2 class="server-ic-view-h2">在线招聘服务</h2>
            <h4 class="server-ic-view-h4">精准快捷, 专业高效的岗位招聘服务</h4>
            <div>
              <button class="server-ic-view-btn" type="button">职位发布</button>
              <button class="server-ic-view-btn1" type="button">APP下载</button>
            </div>
          </div>
        </div>
      </div>
      <div class="server-body">
        <h2 class="server-body-h2 server-body-h2-1">平台优势</h2>
        <div class="server-body-view server-body-view-1">
          <div class="server-body-view-content">
            <div class="server-body-view-left" v-for="(s, i) in com" :key="i">
              <h3 class="server-body-view-title">{{ s.title }}</h3>
              <h5 class="server-body-view-sub">{{ s.sub_title }}</h5>
            </div>
          </div>
          <div class="server-body-view-img">
            <img src="../../../static/Bitmap_server.png" alt="" />
          </div>
        </div>
      </div>

      <div class="server-body-1">
        <div class="server-body-1-content">
          <div class="server-b1c-view server-b1c-view-1">
            <img src="../../../static/VIP_server.png" alt="" />
          </div>
          <div class="server-b1c-view server-b1c-view-2 server-body-h2">
            VIP特权, 迅速提升招聘效果
          </div>
          <div class="server-b1c-view server-b1c-view-3">
            <div class="server-b1c-view-item" v-for="(s, i) in list" :key="i">
              <div class="server-b1c-img">
                <img :src="`../../../static/priority_${i + 1}.png`" alt="" />
              </div>
              <h3 class="server-b1c-title">{{ s.title }}</h3>
              <h5 class="server-b1c-sub">{{ s.sub_title }}</h5>
            </div>
          </div>
          <!-- <div class="server-b1c-view server-b1c-view-4"><button class="server-b1c-view-btn" type="button">我要合作</button></div> -->
          <div class="server-b1c-view server-b1c-view-4">
            <el-button
              class="server-b1c-view-btn"
              type="text"
              @click="dialogFormVisible = true"
              >我要合作</el-button
            >
          </div>
        </div>
      </div>

      <div class="server-body server-body-2">
        <h2 class="server-body-h2 server-body-h2-2">
          用播聘 招聘更快更准更省钱
        </h2>
        <h2 class="server-body-h4">从现在开始让播聘助您一臂之力</h2>
        <div class="server-body-view server-body-view-2">
          <div class="server-body-from">
            <input
              type="text"
              class="server-body-input server-body-input-1"
              placeholder="手机号"
            />
          </div>
          <div class="server-body-from-1">
            <input
              type="text"
              class="server-body-input server-body-input-2"
              placeholder="公司名称"
            />
          </div>
          <!-- <div><button class="server-b1c-view-btn-1" type="button">快联系我吧</button></div> -->
          <div>
            <el-button
              class="server-b1c-view-btn-1"
              type="text"
              @click="dialogFormVisible = true"
              >快联系我吧</el-button
            >
          </div>
          <el-dialog title="快联系我吧" :visible.sync="dialogFormVisible">
            <el-form :model="form">
              <el-form-item label="收集联系人" :label-width="formLabelWidth">
                <el-input
                  v-model="form.name"
                  auto-complete="off"
                  placeholder="请选择联系人的名称"
                ></el-input>
              </el-form-item>
              <el-form-item label="联系方式" :label-width="formLabelWidth">
                <el-input
                  v-model="form.region"
                  auto-complete="off"
                  placeholder="请选择联系方式"
                ></el-input>
                <!-- <el-select v-model="form.region" placeholder="请选择联系方式">
								<el-option label="手机号" value="shanghai"></el-option>
								<el-option label="区域二" value="beijing"></el-option>
							</el-select> -->
              </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
              <el-button @click="dialogFormVisible = false">取 消</el-button>
              <el-button type="primary" @click="dialogFormVisible = false"
                >确 定</el-button
              >
            </div>
          </el-dialog>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Dialog } from "element-ui";
export default {
  name: "EnterpriseServer",
  data() {
    return {
      dialogTableVisible: false,
      dialogFormVisible: false,
      com: [
        {
          title: "覆盖范围广",
          sub_title: "海量移动端求职用户"
        },
        {
          title: "招聘速度快",
          sub_title: "真实视频简历，快速视频面试"
        },
        {
          title: "人才精准匹配",
          sub_title: "在线就能招到最合适的人"
        }
      ],
      list: [
        {
          title: "优先展示",
          sub_title: "职位展示位置在普通 职位上方, 效果倍增"
        },
        {
          title: "醒目标识",
          sub_title: "VIP客户专属标识 吸引用户报名转化"
        },
        {
          title: "一对一服务",
          sub_title: "专业人力资源顾问 提供一对一服务"
        },
        {
          title: "操作便捷",
          sub_title: "后台操作简单方便 招聘效果随时展现"
        }
      ],
      form: {
        name: "",
        region: "",
        date1: "",
        date2: "",
        delivery: false,
        type: [],
        resource: "",
        desc: ""
      },
      formLabelWidth: "120px"
    };
  },
  methods: {
    // handleClose(done) {
    // 	this.$confirm('确认关闭？')
    // 	.then(_ => {
    // 		done();
    // 	})
    // 	.catch(_ => {});
    // }
  }
};
</script>

<style scoped="scoped">
@import url("./enterprise-server.css");
</style>



// WEBPACK FOOTER //
// src/pages/enterprise-server/enterprise-server.vue